/*
 * O meio do cabeçalho. Ao rolar um tópico para além do
 * título, a busca dá lugar ao título do tópico com a categoria e as
 * etiquetas embaixo; clicar no título
 * volta ao topo. Fora disso, é a busca.
 */
import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import Component from 'flarum/common/Component';
import Badge from 'flarum/common/components/Badge';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import HeaderSearch from './HeaderSearch';
import { forumBool } from '../utils/settings';
import { discussionBadges } from '../utils/tags';
let showingTopic = false;
let frame = 0;
function currentDiscussion() {
  return app.current.matches(DiscussionPage) ? app.current.get('discussion') : null;
}

/** O título do tópico já saiu da tela por baixo do cabeçalho? */
function titleScrolledAway() {
  const title = document.querySelector('.DiscussionHero-title');
  const header = document.getElementById('header');
  if (!title || !header) return false;
  return title.getBoundingClientRect().bottom < header.getBoundingClientRect().bottom;
}
function update() {
  frame = 0;
  const next = !!currentDiscussion() && titleScrolledAway();
  if (next !== showingTopic) {
    showingTopic = next;
    m.redraw();
  }
}
function schedule() {
  if (!frame) frame = requestAnimationFrame(update);
}

/**
 * O badge do core cria a dica sem posição (em cima). `tooltipPosition` escolhe
 * outra: no cabeçalho fixo a dica abre para baixo, e não cortada no topo da
 * tela. O atributo sai do elemento do badge (não vai para o DOM).
 */
export function installBadgeTooltipPosition() {
  override(Badge.prototype, 'view', function (original) {
    const position = this.attrs?.tooltipPosition;
    if (!position) return original();
    const {
      tooltipPosition: _ignored,
      ...rest
    } = this.attrs;
    const saved = this.attrs;
    this.attrs = rest;
    try {
      const result = original();
      if (result?.attrs && result.attrs.text !== undefined) result.attrs = {
        ...result.attrs,
        position
      };
      return result;
    } finally {
      this.attrs = saved;
    }
  });
}
export function watchHeaderTopic() {
  window.addEventListener('scroll', schedule, {
    passive: true
  });
  window.addEventListener('resize', schedule, {
    passive: true
  });
}
export default class HeaderCenter extends Component {
  shown = false;
  view() {
    const discussion = currentDiscussion();

    // Ao trocar de página, o estado é refeito antes de desenhar.
    if (!discussion && showingTopic) showingTopic = false;
    this.shown = !!discussion && showingTopic;
    if (discussion && showingTopic) return this.topic(discussion);
    return forumBool('canelaHeaderSearch', true) ? m(HeaderSearch, {
      state: app.search.state
    }) : null;
  }
  oncreate() {
    this.markHeader();
  }
  onupdate() {
    this.markHeader();
    schedule();
  }

  /**
   * A classe no cabeçalho com o título do tópico nele (Header.less,
   * Mobile.less), no lugar de `.App-header:has(.CanelaHeaderTopic)`: o
   * `:has()` fazia o navegador reavaliar o cabeçalho a cada mudança dentro
   * dele. Corre depois do patch e antes da pintura, sem quadro trocado.
   */
  markHeader() {
    document.getElementById('header')?.classList.toggle('CanelaHeader--topic', this.shown);
  }
  topic(discussion) {
    // As dicas dos badges abrem para baixo: em cima, ficariam fora da tela.
    const badges = discussion.badges().toArray().map(badge => badge?.attrs ? {
      ...badge,
      attrs: {
        ...badge.attrs,
        tooltipPosition: 'bottom'
      }
    } : badge);
    return m("div", {
      className: "CanelaHeaderTopic"
    }, m("a", {
      className: "CanelaHeaderTopic-title",
      href: app.route.discussion(discussion),
      onclick: event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0) return;
        event.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }, badges.length > 0 && m("span", {
      className: "CanelaHeaderTopic-status"
    }, badges), m("span", {
      className: "CanelaHeaderTopic-text"
    }, discussion.title())), m("div", {
      className: "CanelaHeaderTopic-badges"
    }, discussionBadges(discussion)));
  }
}
flarum.reg.add('ramon-canela', 'forum/shell/HeaderCenter', HeaderCenter);